<template>
  <v-container fluid>
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('games.listTitle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-switch
          class="mt-0 mb-2"
          hide-details
          :label="$t('gameVersions.dd')"
          v-model="ddFilter"
        ></v-switch>
        <v-switch
          class="mt-0 mb-2"
          hide-details
          :label="$t('gameVersions.standard')"
          v-model="standardFilter"
        ></v-switch>
        <v-switch
          class="mt-0 mb-2"
          hide-details
          :label="$t('games.favorites')"
          v-model="favoriteFilter"
        ></v-switch>
         <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
        
      </v-card-title>
      <data-table
        :disableInitalSort="true"
        :loading="gamesLoading"
        :items="formatedGamesList"
        :headers="gamesHeaders"
        :search="search"
        @selected="(value) => selected = value"
        @edit="editSelection"
        @logo="editFav"
      ></data-table>
    </v-card>
    <v-fab-transition>
      <v-btn v-if="showAddButton" fab dark color="primary" bottom right fixed @click.native="editMode = 'add'; addDialog = true">
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fab
        dark
        color="red"
        bottom
        right
        fixed
        @click.native="deleteDialog = true"
        style="right: 80px;"
        v-if="selected.length > 0"
        >
        <v-icon dark>delete</v-icon>
      </v-btn>
    </v-fab-transition>
    <game-add :active="addDialog" @closedialog="addDialog = false"></game-add>
    <confirmation-dialog :active="deleteDialog" title="Confirmation ?" :message="$tc('games.deleteConfirmation', selected.length, {count: selected.length})" :loading="gamesLoading" @confirmation="deleteGames" @cancel="deleteDialog = false"></confirmation-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DataTable from "@/components/DataTable";
import GameAdd from "./Game-add"
import ConfirmationDialog from "@/components/ConfirmationDialog"

export default {

  name: "Games",

  components: {
    DataTable,
    GameAdd,
    ConfirmationDialog
  },

  data() {
    return {
      showAddButton: false,
      search: "",
      selected: [],
      addDialog: false,
      deleteDialog: false,
      editMode: "add",
      ddFilter: true,
      standardFilter: true,
      favoriteFilter: false,
      filterSelection: 0,
      filters: [
        {
          name: "DD",
          value: 1
        },
        {
          name: "Classique",
          value: 2
        },
        {
          name: "Favoris",
          value: 3
        }
      ]
    };
  },

  mounted() {
    this.getAllGames();
    setTimeout(() => this.showAddButton = true, 500)
  },

  methods: {

    editSelection(value) {
      this.$router.push('/in-game/' + value + '/companies')
    },

    async editFav(value) {
      await this.updateFav({
        id: value,
        params: null
      })
    },

    async deleteGames() {
      if (await this.deleteGamesAction(this.selected.map(item => item._id))){
        this.deleteDialog = false
        this.selected = []
      }
    },

    ...mapActions('games', {
      getAllGames: 'getAll',
      deleteGamesAction: 'delete',
      updateFav: 'updateFav'
    })

  },

  computed: {

    formatedGamesList () {
      return this.allGames.filter(game => {
        if (this.favoriteFilter && !game.fav) return false
        if (!this.ddFilter && game.gameVersion.dd) return false
        if (!this.standardFilter && !game.gameVersion.dd) return false
        return true
      })
      .map(game => {
        game.favLogo = game.fav ? "star" : "star_border"
        game.dd = game.gameVersion.dd ? this.$t('general.yes') : this.$t('general.no')
        game.statusName = this.gameStatus[game.status + (game.connectedPlayer > 0 ? 1 : 0)]
        game.createdBy = game.user.login
        game.version = game.gameVersion.name
        game.createdAtFormated = new Date(game.createdAt).toLocaleDateString()
        return game 
      })
    },

    ...mapGetters('games', {
      gameStatus: 'status',
      allGames: 'list',
      gamesHeaders: 'headers',
      gamesLoading: 'loading'
    })
  }
};
</script>
